/************************************************************
 * Project: Book App
 * Author: Marcos Santos - A01072792
 * BCIT class Comp2913 - ReactJS by Daniel Takeuchi
 * Date: October, 10, 2020.
 * Description: Assignment - Book App
 * https://github.com/maasantos10/
 ************************************************************/

import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  body {
    background: #312E38;
    color: #FFF;
    -webkit-font-smoothing: antialiased;
    
  }

  

  border, input, button {
    font-family: 'Roboto Slab', serif;
    font-size: 16px;
  }


  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500px;
  }

  button {
    cursor: pointer;
  }
`;
